const STEP_LABELS = { big: "สูง", small: "ต่ำ", odd: "คี่", even: "คู่" };

// "step"-stake bets store `number` as an object keyed by position
// (e.g. { first: "odd", second: "big", third: "even" }) instead of a
// plain digit string, so it can't be rendered as a React child directly.
export function formatBetNumber(number) {
  if (number && typeof number === "object") {
    return Object.values(number)
      .map((value) => STEP_LABELS[value] || value)
      .join("-");
  }
  return number;
}
